// removed by extract-text-webpack-plugin
module.exports = {"center":"_11LsJ_t53VUrNlzP_gX6r0","FileBubble":"_2Sq2z8v2kBDMwQtEufGscM","FileBubbleSending":"_1mGocPgC0_NWQoe5SB2Mrc","FileCancelButton":"_3wFv5bqlRNeJc53EtL71c7","FileBubbleText":"_2f6Fy-BEcktZPn1QmP0UGX","FileBubbleTextSending":"_30x_QmX9MdUcsCeFTF_ydW","LoadingFile":"_282dRr6v8Fj8Rmsp-76UoA","messageBox":"_1C5_LVdco-AM-fmAE2ofjp","SmileyModalWrapper":"_2kxS3CKvzpVV-iQh6bewYH","iconsTopBorder":"_1Nz-EQzweg-NkDg4fyHy6n"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/Conversation/style.css
// module id = 1998
// module chunks = 0